/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { isEmpty, join } from "lodash";

export interface ICountry {
    id?: string;
    name?: string;
    phoneCode?: string;
    flag?: string;
    primary?: boolean;
}

export interface IProvince {
    id: string;
    name: string;
}

export interface IDistrict {
    provinceId: string;
    id: string;
    name: string;
    postcode?: string[];
}

export interface ISubdistrict {
    cityId: string;
    id: string;
    name: string;
    postcode?: string[];
}

export interface IAddress {
    id: string;
    firstName: string;
    lastName: string;
    fullName?: string;
    phone: string;
    country: ICountry;
    province: IProvince;
    district: IDistrict;
    subDistrict: ISubdistrict;
    postcode: number;
    address: string;
    typeOfPlace: string;
    fullAddress?: string;
    typeOfPlaceId?: string;
    isDefault: boolean;
    remark?: string;
    nickName?: string;
}

export interface IServiceAddress extends IAddress {
    nickName: string;
    nameOfPlace?: string;
    remark?: string;
}

export interface IBillingAddress extends IAddress {
    email: string;
    citizenId: string;
    taxId: string;
    companyName: string;
    typeOfCustomer: string;
    sameServiceAddress?: boolean;
}

export interface IAddressFormShow {
    typeOfPlace?: boolean;
    remark?: boolean;
    map?: boolean;
    country?: boolean;
    address?: boolean;
}

export const getFullAddress = (address: any) => {
    if (!address) {
        return "";
    }
    const arrayAddress = [
        address.address,
        address?.subDistrict?.name,
        address?.district?.name,
        address?.province?.name,
        address?.postcode,
    ];

    return join(arrayAddress, ", ");
};

export const mapAddressFromSer = (address: any) => {
    const { firstName, lastName } = address;
    const fullAddress = getFullAddress(address);
    return {
        ...address,
        fullAddress,
        fullName: `${firstName} ${lastName}`,
    };
};

export const mapAddressToForm = (addressDefault: any) => {
    if (!addressDefault) {
        return {
            isDefault: false,
        };
    }

    const { id, fullName, fullAddress, ...rest } = addressDefault;
    return {
        isDefault: false,
        ...rest,
    };
};

export const mapAddressToSer = (addressDefault: any) => {
    if (!addressDefault) {
        return {
            country: "Thai",
        };
    }

    const {
        province,
        district,
        subDistrict,
        zoom,
        country,
        address,
        firstName,
        gender,
        isDefault,
        lastName,
        latitude,
        longitude,
        nameOfPlace,
        nickName,
        phone,
        postcode,
        remark,
        typeOfPlace,
    } = addressDefault;
    return {
        country: country?.id,
        province: province?.id,
        district: district?.id,
        subDistrict: subDistrict?.id,
        address,
        firstName,
        gender,
        isDefault,
        lastName,
        latitude,
        longitude,
        nameOfPlace,
        nickName,
        phone,
        postcode,
        remark,
        typeOfPlace,
    };
};

export const mapBillingToSer = (billingInput: any) => {
    const {
        province,
        district,
        subDistrict,
        country,
        address,
        firstName,
        gender,
        isDefault,
        lastName,
        latitude,
        longitude,
        nameOfPlace,
        nickName,
        phone,
        postcode,
        remark,
        typeOfPlace,
        typeOfCustomer,
        citizenId,
        email,
        companyName,
        companyPhone,
        taxId,
    } = billingInput;
    return {
        country: country?.id,
        province: province?.id,
        district: district?.id,
        subDistrict: subDistrict?.id,
        address,
        firstName,
        gender,
        isDefault,
        lastName,
        latitude,
        longitude,
        nameOfPlace,
        nickName,
        phone,
        postcode,
        remark,
        typeOfPlace,
        typeOfCustomer,
        citizenId,
        email,
        companyName,
        companyPhone,
        taxId,
    };
};
